import { _ } from '@ngx-translate/core';

import type { ContractRenewal, ContractRenewalRow, ContractRenewalTone, NoticeStep } from './contract-renewals.models';

const COUNTDOWN_TONE: Record<Extract<NoticeStep, 'last_week' | 'window_open'>, ContractRenewalTone> = {
  last_week: 'urgent',
  window_open: 'warning',
};

type RowLabel = Pick<ContractRenewalRow, 'label' | 'labelParams'>;

const countdown = (days: number, singular: string, plural: string): RowLabel =>
  days === 1 ? { label: singular } : { label: plural, labelParams: { days } };

const toLabelAndTone = ({ days_left, notice }: ContractRenewal): RowLabel & { tone: ContractRenewalTone } => {
  if (!notice || notice.step === 'before_window') {
    return { ...countdown(days_left, _('Ends in 1 day'), _('Ends in [days] days')), tone: 'muted' };
  }

  if (notice.step === 'passed') {
    return { label: _('Notice deadline passed'), tone: 'critical' };
  }

  return {
    ...countdown(notice.days_left, _('Notice due in 1 day'), _('Notice due in [days] days')),
    tone: COUNTDOWN_TONE[notice.step],
  };
};

export const toContractRenewalRow = (
  renewal: ContractRenewal,
  canViewContracts: (employeeId: string) => boolean,
): ContractRenewalRow => ({
  contractId: renewal.contract_id,
  employeeName: renewal.employee_name,
  ...toLabelAndTone(renewal),
  lastWorkingDay: renewal.last_working_day,
  link: canViewContracts(renewal.employee_id) ? ['/employees', renewal.employee_id, 'contracts'] : null,
});
